import { useQuery } from '@tanstack/react-query';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { apiClient } from '../../../utils/axios';
import { AxiosError } from 'axios';
import { showSnackbar } from '../../../api/snackbarSlice';

export const fetchProducts = async ({ queryKey }) => {
  const [, params] = queryKey;
  const { data } = await apiClient.get('/products', { params });
  return data;
};

export const useGetProductsHandler = ({ searchQuery }) => {
  const dispatch = useDispatch();
  const [products, setProducts] = useState([]);
  const [totalDocuments, setTotalDocuments] = useState(0);

  const {
    data: fetchedData,
    isLoading,
    isError,
    error,
  } = useQuery({
    queryKey: ['products', searchQuery],
    queryFn: fetchProducts,
    keepPreviousData: true,
    refetchOnWindowFocus: true,
  });

  useEffect(() => {
    if (fetchedData) {
      setProducts(fetchedData.content);
      setTotalDocuments(fetchedData.total_elements);
    }
  }, [fetchedData]);

  useEffect(() => {
    if (isError) {
      if (error instanceof AxiosError) {
        dispatch(showSnackbar({ message: error.response?.data?.message || error.message, severity: 'error' }));
      } else {
        dispatch(showSnackbar({ message: JSON.stringify(error), severity: 'error' }));
      }
    }
  }, [dispatch, error, isError]);

  return {
    products,
    totalDocuments,
    isLoading,
  };
};
